import {
	ChangeDetectionStrategy,
	Component,
	computed,
	ContentChild,
	contentChild,
	ElementRef,
	inject,
	input,
	model,
	output,
	Signal,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';

import { BaseDirective } from '@valk-nx/core/lib/directives/base/base.directive';
import { GeneralHelper } from '@valk-nx/helpers/lib/general/general.helper';
import { ViewPortService } from '@valk-nx/services/viewport/src/lib/viewport.service';

import { SheetFooterDirective } from './sheet.directive';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	host: {
		'(document:click)': 'onClickSheet($event)',
		'(document:keydown)': 'onKeydownHandler($event)',
	},
	selector: 'vp-sheet',
	standalone: false,
	templateUrl: './sheet.html',
})
export class SheetComponent extends BaseDirective {
	private readonly viewport = inject(ViewPortService);

	triggerId = input('');
	className = input('');
	clickExclusives = input<string[]>([]);
	clickInclusives = input<string[]>([]);
	sheetWidth = input<'third' | 'half' | 'quarter'>('half');
	sheetAlignment = input<'left' | 'right'>('right');
	isLoading = input(true);

	showSheet = model(false);

	@ContentChild('sheetTrigger') triggerRef!: ElementRef;
	@ViewChild('sheetContentWrapper') sheetRef!: ElementRef;
	footerRef = contentChild(SheetFooterDirective);
	emitClose = output<void>();

	isMobile: Signal<boolean> = this.viewport.isMobile;

	sheetWidthClass = computed(() => {
		switch (this.sheetWidth()) {
			case 'third':
				return 'w-1/3';
			case 'quarter':
				return 'w-1/4';
			case 'half':
				return 'w-1/2';
		}
	});

	scrollPosition = 0;

	show() {
		this.showSheet.set(true);
		this.scrollPosition = window.scrollY;
		GeneralHelper.bodyLock(true, this.scrollPosition);
	}

	hide() {
		if (this.showSheet()) {
			this.showSheet.set(false);
			GeneralHelper.bodyLock(false, this.scrollPosition);
			this.emitClose.emit();
		}
	}

	toggle() {
		if (this.showSheet()) {
			this.hide();
		} else {
			this.show();
		}
	}

	onClickSheet(e: Event) {
		const target = e.target as HTMLInputElement;
		if (
			target.id === this.triggerId() ||
			(target.id && this.clickInclusives().includes(target.id))
		) {
			this.toggle();
		}
	}

	onKeydownHandler(event: KeyboardEvent) {
		if (event.key === 'Escape') {
			this.hide();
		}
	}
}
